import { Box } from "@mui/material";
import CalendarEvents from "../../components/calendar/CalendarEvents";
import FabEyeButton from "../../components/user-activity-fab/UserActivityFab";

const CalendarPage = () => {
  return (
    <Box>
      <CalendarEvents />
      <FabEyeButton />
    </Box>
  );
};

export default CalendarPage;
